<template>
  <div class="flex flex-col items-start p-4 rounded-xl">
    <div class="text-primary-100 font-semibold text-lg leading-26">Neler Oluyor?</div>
    <NewsSidebarItem v-for="(article, index) in articles" :key="article._id" :article="article" :index="index" />
  </div>
</template>
<script>
import { computed, defineComponent, onBeforeMount, ref, useContext } from '@nuxtjs/composition-api';
import NewsSidebarItem from './NewsSidebarItem';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { OLink, OIcon } from '~/modules/common/components/ui';
export default defineComponent({
  props: {},
  components: { OLink, OIcon, NewsSidebarItem },
  setup() {
    const { $service } = useContext();
    const news = ref([]);
    const isBreakingNews = ref(false);

    onBeforeMount(async () => {
      const breakingNewsLocalStore = await localStore.getItem('o-breaking-news');
      const breakingNewsTypeLocalStore = await localStore.getItem('o-breaking-news-type');

      if (breakingNewsLocalStore) {
        news.value = breakingNewsLocalStore;
        isBreakingNews.value = breakingNewsTypeLocalStore;
      } else {
        try {
          const { data: result, extraData } = await $service.article.getBreakingNews();
          news.value = result;
          isBreakingNews.value = extraData.isBreakingNews;
          localStore.setItem('o-breaking-news', result, { expireMs: 60 }); // 1 mins
          localStore.setItem('o-breaking-news-type', extraData.isBreakingNews, { expireMs: 60 }); // 1 mins
        } catch {
          news.value = ref([]);
        }
      }
    });

    const articles = computed(() => news.value.slice(0, 5));

    return { articles };
  },
});
</script>
